export const NO_REGION = '123e4567-e89b-12d3-a456-426655440000';
export const ALL_RUSSIA = '774ebed3-153d-4ba9-8532-8bdf879e1f5a';
export const ALL_RUSSIA_NAME = ' Вся Россия'; // пробел в начале для удобства сортировки
